module.exports = __webpack_public_path__ + "static/media/zoom.85384ba0.svg";